module.exports = __webpack_public_path__ + "static/media/bob.fec4f50d.svg";